<template>
  <div class="dialog-container wt-dialog-container">
    <wt-readonly-form-section ref="formSection" :detail-form-data.sync="detailData" :detail-form.sync="detailForm" :readonly="true" ></wt-readonly-form-section>
    <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
  </div>
</template>

<script>
export default {
  name: 'SiteOrganizationViewPage',
  props: ['component-type', 'detailData'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: '',
      isSubmitLoading: false,
      detailFormButtons: {
        title: '机构详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '机构详情',
        className: 'wt-section-long-content',
        elements: [
          // { name: '结构层级',
          //   key: 'level',
          //   type: 'select',
          //   data: [
          //     { label: '总公司', value: 1 },
          //     { label: '分公司', value: 2 },
          //     { label: '项目部', value: 3 }
          //   ],
          //   className: 'wt-col-12',
          //   disabled: true },
          // { name: '上级机构名称', key: 'parentName', type: 'text', className: 'wt-col-12', disabled: true },
          // { name: '机构名称', key: 'name', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '总公司', key: 'name1', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '分公司', key: 'name2', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '项目部', key: 'name3', type: 'text', className: 'wt-col-12', disabled: true }
        ]
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    }
  }
}
</script>

<style scoped>
.detail-img {
  width: 80px;
  height: 80px;
  margin-right: 20px;
}
</style>
